
import atlas from "@/components/atlas.vue";
import { eventUploadMixin } from '@/plugins/hwtag/events';
export default {
  mixins: [eventUploadMixin],
  data() {
    return {
      navId: 0,
      tab: 1,
      navActive:'',
      // 屏幕滚动
      scrollTop: 0,
      currentPage: 1,
      source: '',
      bannerH: 0,
      headerH: 0,
      WindowWidth:'',
      imgUrl: 'https://resource.xp-pen.com/img/Contest/ChristmasContest2024/',
      sidebar: 'en',
      sliderList: [
        {
          type: 'en',
          lang: 'English'
        },
        {
          type: 'de',
          lang: 'Deutsch'
        },
        {
          type: 'es',
          lang: 'Español'
        },
        {
          type: 'pt',
          lang: 'Português'
        },
        {
          type: 'it',
          lang: 'Italiano'
        },
        {
          type: 'fr',
          lang: 'Français'
        },
        {
          type: 'jp',
          lang: '日本語'
        },
        {
          type: 'kr',
          lang: '한국어'
        },
        {
          type: 'pl',
          lang: 'Polska'
        },
        {
          type: 'ru',
          lang: 'Русский язык'
        }
      ],
      meritWinnerList: [
        {
          winnerName: '@rajathk',
          winnerHref: 'https://community.xp-pen.com/gallery/30133'
        },
        {
          winnerName: '@ye0nyh',
          winnerHref: 'https://community.xp-pen.com/gallery/29997'
        },
        {
          winnerName: '@bakamaru',
          winnerHref: 'https://community.xp-pen.com/gallery/29963'
        },
        {
          winnerName: '@XFANSzhszcgh3',
          winnerHref: 'https://community.xp-pen.com/gallery/29738'
        },
        {
          winnerName: '@XFANSzmb0tsoi',
          winnerHref: 'https://community.xp-pen.com/gallery/29813'
        },
        {
          winnerName: '@sandeep_avalokitharts',
          winnerHref: 'https://www.instagram.com/p/DCsi2ziCW2x/'
        }
      ],
    };
  },
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "The Journey of Miracles 2024 XPPen Christmas Drawing Contest",
      meta: [
        {
          name: "keywords",
          content: "The Journey of Miracles, XPPen, Christmas Drawing Contest",
        },
        {
          hid: "description",
          name: "names",
          content: "We often look forward to Christmas because it embodies the fulfillment of dreams, the warmth of love, and the miracles of the heart.",
        },
      ],
    };
  },
  components: { atlas },
  computed: {},
  watch: {
    sidebar: {
      handler: function (val) {
        this.$i18n.locale = val
      },
      deep: true,
      immediate: true
    }

  },
  mounted() {
    this.WindowWidth = window.innerWidth;
    this.bannerH = this.$refs.bannerHeight.offsetHeight;
    this.headerH = document.getElementsByTagName('header')[0].offsetHeight;
    this.parametricWork();
    window.addEventListener('scroll', this.handleScroll, true);
    if (this.$route.query.lang) {
      const lang = this.$route.query.lang;
      this.changeLanguage(lang);
    }
  },
  methods: {
    // 作品方法
    async parametricWork(type, page = 1) {
      let res = await this.$global.parametricWork({ "activityId": 45, "page": page, "award": 0 });
      // res.code = '200' ? (this.source = res.result) : []
      this.source = res;
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.parametricWork(28, this.currentPage);
    },
    // 滚动方法
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    //侧边导航锚点滚动
    handleScrollTo(id) {
      const element = document.getElementById(id);
      const navHeight = document.getElementById('navContent');
      console.log(element.getBoundingClientRect().top)
      const top = (element.getBoundingClientRect().top + window.pageYOffset) - navHeight.offsetHeight - 100;
      window.scroll({ top, behavior: 'smooth' });
      this.navActive = id;
      if(id === 'winner') {
        this.navId = 0;
      }else {
        this.navId = 1;
      }
    },
    //语言栏切换
    changeLanguage(lang) {
      this.sidebar = lang;
      this.$loadLanguageAsync(lang);
    },
    //rules tab
    handelTab (tabIndex) {
      this.tab = tabIndex;
    }
  },
};
